// Configurazione delle 3 landing "RC Professionale" per le campagne Google Ads.
// Ogni voce guida il componente riutilizzabile RCProfessionale.jsx.

export const RC_PROFESSIONALE = {
  "rc-professionale-commercialisti-avvocati": {
    eyebrow: "RC Professionale · Area giuridico-economica",
    h1: { pre: "RC Professionale per", hi: "commercialisti, avvocati", post: "e consulenti del lavoro." },
    image: "https://images.unsplash.com/photo-1642522029686-5485ea7e6042?auto=format&fit=crop&w=1920&q=80",
    introHtml:
      "La <strong>polizza di Responsabilità Civile Professionale</strong> è obbligatoria per gli iscritti agli albi e tutela lo studio da errori, omissioni e negligenze. Per <strong>commercialisti, consulenti del lavoro, avvocati e revisori</strong>, XL Brokers costruisce coperture <strong>in formula ALL RISK</strong> — che proteggono tutti i rischi salvo le sole esclusioni indicate — comprese le attività a maggior rischio. Con l'indipendenza di un broker che lavora <strong>solo per te</strong>.",
    copertureIntro:
      "Costruiamo il programma in formula ALL RISK, con retroattività e postuma adeguate, comprese le attività a maggior rischio come collegio sindacale, revisione legale e OCC — estensioni che nel mercato si pagano spesso a parte.",
    coperture: [
      "Formula ALL RISK: tutti i rischi salvo esclusioni",
      "Consulenza fiscale, contabile, societaria e del lavoro",
      "Attività ad alto rischio: sindaco, revisore, OCC e CTU",
      "Danni patrimoniali a clienti e a terzi",
      "Responsabilità di soci, collaboratori e praticanti",
      "Retroattività illimitata e postuma pluriennale",
    ],
    altreTitle: "Un unico partner per tutti i rischi dello studio.",
    altreIntro:
      "Oltre alla RC Professionale, progettiamo l'intero programma assicurativo dello studio: dalla tutela legale alla protezione dei dati dei clienti.",
    altre: [
      { t: "Tutela Legale", d: "Assistenza in ambito contrattuale, penale e recupero crediti dello studio." },
      { t: "Cyber Risk & GDPR", d: "Protezione da data breach e violazioni sui dati fiscali e personali dei clienti." },
      { t: "RC verso Terzi", d: "Danni a persone e cose all'interno dei locali dello studio." },
      { t: "Infortuni e Malattia", d: "Diarie e capitali a tutela del professionista e dei collaboratori." },
      { t: "All Risks Studio", d: "Furto, incendio e danni a hardware, archivi e attrezzature d'ufficio." },
      { t: "Tutela del Patrimonio", d: "Protezione del patrimonio personale del professionista e della famiglia." },
      { t: "Convenzioni di Categoria", d: "Condizioni dedicate per ordini professionali e associazioni." },
      { t: "Employee Benefit", d: "Welfare, sanitaria integrativa e previdenza per lo studio strutturato." },
    ],
    faq: [
      {
        q: "La RC Professionale è obbligatoria per commercialisti e avvocati?",
        a: "Sì. Per tutti gli iscritti agli albi è obbligatoria per legge (L. 247/2012 per gli avvocati, D.P.R. 137/2012 per gli altri ordini). Copre i danni patrimoniali causati a clienti e terzi nell'esercizio della professione.",
      },
      {
        q: "Cosa significa copertura in formula ALL RISK?",
        a: "Significa che la polizza copre tutti i rischi connessi all'attività, salvo le sole esclusioni espressamente indicate in contratto: un perimetro molto più ampio rispetto alle polizze a rischi nominati.",
      },
      {
        q: "Sono coperte anche le attività ad alto rischio come sindaco o revisore?",
        a: "Sì. Estendiamo la copertura anche agli incarichi a maggior rischio — collegio sindacale, revisione legale, OCC e CTU — che nelle polizze standard sono spesso esclusi o tariffati a parte.",
      },
      {
        q: "Cosa sono retroattività e postuma?",
        a: "La retroattività copre i fatti commessi prima della stipula ma denunciati durante il contratto; la postuma protegge dopo la cessazione dell'attività. Le calibriamo sulla storia del tuo studio.",
      },
    ],
    ctaTitle: "Pronto a proteggere il tuo studio?",
    ctaText: "Compila il modulo o chiamaci: affianchiamo studi professionali e liberi professionisti in tutta Italia.",
    formOggetto: "Richiesta consulenza RC Professionale — Commercialisti/Avvocati",
    attivitaPlaceholder:
      "Es. studio di commercialisti con tenuta contabilità, consulenza fiscale e del lavoro; incarichi di revisione e collegio sindacale.",
  },

  "rc-professionale-tecnici": {
    eyebrow: "RC Professionale · Professioni tecniche",
    h1: { pre: "RC Professionale per", hi: "architetti, ingegneri", post: "geometri e tecnici." },
    image: "https://images.unsplash.com/photo-1632862378069-4ad0348cea4f?auto=format&fit=crop&w=1920&q=80",
    introHtml:
      "La <strong>Responsabilità Civile Professionale</strong> è obbligatoria (DPR 137/2012) e presidia il tecnico da errori di progettazione, calcolo e direzione lavori. Per <strong>architetti, ingegneri, geometri, periti e coordinatori sicurezza</strong>, XL Brokers costruisce coperture <strong>in formula ALL RISK</strong> — che proteggono tutti i rischi salvo le sole esclusioni indicate — comprese le cosiddette <strong>grandi opere</strong>. Con l'indipendenza di un broker che lavora <strong>solo per te</strong>.",
    copertureIntro:
      "Costruiamo il programma in formula ALL RISK, con retroattività e postuma decennale, comprese le cosiddette grandi opere e gli incarichi ad alto rischio — estensioni che nel mercato si pagano spesso a parte.",
    coperture: [
      "Formula ALL RISK: tutti i rischi salvo esclusioni",
      "Progettazione, direzione lavori e collaudo",
      "Grandi opere e incarichi strutturali ad alto rischio",
      "Coordinamento sicurezza (D.Lgs. 81/2008)",
      "Danni a terzi, rivalsa INAIL/INPS e solidale",
      "CTU, perizie, certificazioni, retroattività e postuma decennale",
    ],
    altreTitle: "Un unico partner per tutti i rischi dello studio tecnico.",
    altreIntro:
      "Oltre alla RC Professionale, progettiamo l'intero programma assicurativo del tecnico: dalla postuma decennale alla protezione degli strumenti di lavoro.",
    altre: [
      { t: "Postuma Decennale", d: "Copertura dei danni emersi dopo l'ultimazione dell'opera progettata o diretta." },
      { t: "Tutela Legale", d: "Assistenza in ambito contrattuale, penale sicurezza/ambiente e recupero crediti." },
      { t: "Cyber Risk & GDPR", d: "Protezione da data breach e perdita di progetti e archivi digitali." },
      { t: "All Risks Attrezzature", d: "Furto, danni e rotture su strumenti di rilievo, laptop e apparecchiature." },
      { t: "Infortuni e Malattia", d: "Diarie e capitali a tutela del professionista e dei collaboratori." },
      { t: "Fidejussioni e Garanzie", d: "Garanzie richieste da bandi, incarichi pubblici e capitolati." },
      { t: "Tutela del Patrimonio", d: "Protezione del patrimonio personale del professionista e della famiglia." },
      { t: "Employee Benefit", d: "Welfare, sanitaria integrativa e previdenza per lo studio strutturato." },
    ],
    faq: [
      {
        q: "La RC Professionale è obbligatoria per architetti, ingegneri e geometri?",
        a: "Sì, dal 2013 (D.P.R. 137/2012) per tutti i professionisti tecnici iscritti agli albi. Il committente può richiederne evidenza prima del conferimento dell'incarico.",
      },
      {
        q: "Cosa significa copertura in formula ALL RISK?",
        a: "Copre tutti i rischi dell'attività tecnica salvo le sole esclusioni indicate in polizza, con un perimetro più ampio rispetto alle polizze a rischi nominati.",
      },
      {
        q: "Sono coperte le grandi opere e gli incarichi complessi?",
        a: "Sì. Includiamo anche le cosiddette grandi opere e gli incarichi ad alto rischio (opere strutturali rilevanti, appalti pubblici), che nelle polizze standard sono spesso esclusi o limitati.",
      },
      {
        q: "La polizza copre direzione lavori e coordinamento sicurezza?",
        a: "Sì: comprende progettazione, direzione lavori, collaudo e coordinamento sicurezza ex D.Lgs. 81/2008, con postuma decennale sull'opera realizzata.",
      },
    ],
    ctaTitle: "Pronto a proteggere la tua professione?",
    ctaText: "Compila il modulo o chiamaci: affianchiamo studi tecnici e liberi professionisti in tutta Italia.",
    formOggetto: "Richiesta consulenza RC Professionale — Tecnici",
    attivitaPlaceholder:
      "Es. studio di ingegneria/architettura con progettazione strutturale, direzione lavori e coordinamento sicurezza per cantieri privati e pubblici.",
  },

  "rc-professionale-medici": {
    eyebrow: "RC Professionale · Area sanitaria",
    h1: { pre: "RC per medici, odontoiatri,", hi: "poliambulatori", post: "e centri odontoiatrici." },
    image: "https://images.unsplash.com/photo-1758205307783-f31fe8499814?auto=format&fit=crop&w=1920&q=80",
    introHtml:
      "La <strong>Responsabilità Civile in ambito sanitario</strong> è obbligatoria e, con la <strong>Legge Gelli-Bianco (L. 24/2017)</strong>, richiede garanzie di adeguatezza precise sia per il professionista sia per la struttura. Per <strong>medici e odontoiatri liberi professionisti, poliambulatori e centri odontoiatrici</strong>, XL Brokers costruisce coperture <strong>in formula ALL RISK</strong> — che proteggono tutti i rischi salvo le sole esclusioni indicate — comprese le specialità a maggior rischio. Con l'indipendenza di un broker che lavora <strong>solo per te</strong>.",
    copertureIntro:
      "Costruiamo il programma in formula ALL RISK, nel rispetto della Legge Gelli-Bianco, con retroattività e ultrattività decennale — sia per il singolo professionista sia per poliambulatori e centri odontoiatrici — comprese le specialità e le attività a maggior rischio.",
    coperture: [
      "Formula ALL RISK: tutti i rischi salvo esclusioni",
      "Colpa medica e responsabilità professionale",
      "RC della struttura: poliambulatori e centri odontoiatrici",
      "Adeguamento alla Legge Gelli-Bianco (L. 24/2017)",
      "Specialità e attività a maggior rischio (chirurgia, implantologia)",
      "Responsabilità solidale e azione di rivalsa della struttura",
      "Attività intra ed extra moenia, retroattività e ultrattività decennale",
    ],
    altreTitle: "Un unico partner per tutti i rischi dello studio o della struttura.",
    altreIntro:
      "Oltre alla RC, progettiamo l'intero programma assicurativo dell'esercente sanitario e della struttura: dalla tutela legale penale alla protezione delle apparecchiature.",
    altre: [
      { t: "Tutela Legale Sanitaria", d: "Assistenza legale, anche penale, per contenziosi con pazienti e terzi." },
      { t: "RC Struttura & Pazienti", d: "Danni a persone e cose in poliambulatori, centri odontoiatrici e studi." },
      { t: "Cyber Risk & Dati Sanitari", d: "Protezione da data breach sui dati sanitari (categorie particolari GDPR)." },
      { t: "Infortuni e Malattia", d: "Diaria da ricovero e capitali a tutela del professionista." },
      { t: "All Risks Apparecchiature", d: "Riuniti, strumentazione diagnostica e apparecchiature medicali." },
      { t: "Interruzione Attività", d: "Indennizzo per la sospensione dell'attività dello studio o della struttura a seguito di sinistro." },
      { t: "Tutela del Patrimonio", d: "Protezione del patrimonio personale del professionista e della famiglia." },
      { t: "Employee Benefit", d: "Welfare, sanitaria integrativa e previdenza per lo studio o la struttura." },
    ],
    faq: [
      {
        q: "La RC è obbligatoria anche per poliambulatori e centri odontoiatrici?",
        a: "Sì. La Legge Gelli-Bianco (L. 24/2017) impone una copertura adeguata sia all'esercente la professione sanitaria sia alla struttura (poliambulatori, centri odontoiatrici, cliniche), a tutela del paziente.",
      },
      {
        q: "Che differenza c'è tra RC del professionista e RC della struttura?",
        a: "La RC professionale copre il singolo medico o odontoiatra; la RC di struttura copre poliambulatori e centri odontoiatrici per l'attività complessiva e i collaboratori. Spesso servono entrambe e le coordiniamo in un unico programma.",
      },
      {
        q: "Cosa significa copertura in formula ALL RISK?",
        a: "La polizza copre tutti i rischi dell'attività sanitaria salvo le sole esclusioni indicate, offrendo un perimetro più ampio rispetto alle polizze a rischi nominati.",
      },
      {
        q: "È coperta anche l'azione di rivalsa della struttura?",
        a: "Sì. Con la Legge Gelli la struttura può rivalersi sul professionista in caso di colpa grave: la polizza tutela il medico anche in questa ipotesi.",
      },
      {
        q: "Cos'è l'ultrattività (postuma) decennale?",
        a: "È la garanzia che copre le richieste di risarcimento presentate dopo la cessazione dell'attività, per almeno 10 anni, come richiesto dalla normativa.",
      },
    ],
    ctaTitle: "Pronto a proteggere il tuo studio o la tua struttura?",
    ctaText: "Compila il modulo o chiamaci: affianchiamo medici, odontoiatri, poliambulatori e centri odontoiatrici in tutta Italia.",
    formOggetto: "Richiesta consulenza RC Area Sanitaria (medici/odontoiatri/strutture)",
    attivitaPlaceholder:
      "Es. centro odontoiatrico con 4 riuniti, implantologia e ortodonzia, collaboratori igienisti; oppure poliambulatorio polispecialistico.",
  },
};

export const VANTAGGI_RC = [
  { icon: "ShieldCheck", t: "Coperture ALL RISK", d: "Tutti i rischi della professione salvo le sole esclusioni indicate: un perimetro più ampio delle polizze standard." },
  { icon: "Zap", t: "Analisi dedicata", d: "Un consulente valuta la tua esposizione e ti ricontatta entro 24 ore lavorative." },
  { icon: "HandshakeIcon", t: "Broker indipendente", d: "Confrontiamo più compagnie e scegliamo la soluzione migliore per te, non per la compagnia." },
];

export const PROCESSO_RC = [
  { t: "Compili il modulo", d: "Ci bastano i tuoi dati, la professione e un'idea del fatturato/massimale desiderato." },
  { t: "Ti ricontattiamo entro 24h", d: "Un consulente dedicato per approfondire attività, incarichi tipo e coperture già in essere." },
  { t: "Ricevi l'analisi", d: "Ti presentiamo il programma di RC professionale più adatto, selezionato sul mercato. Senza impegno." },
];
